import { FC } from 'react';
import {
	CardContainer,
	CardContentContainerMobile,
	CardTextContainer,
	SimplifiedCardContent,
	SimplifiedCardTitle,
	SimplifiedCardParagraph,
} from './productCard.styled';
import { useACF } from '@context/ACFContext';
import { Button } from '@components/core/button/Button';
import { PostTemplate, MainProduct, PromotionalCard } from 'types/globalTypes';
import DiscountLabel from './discountLabel/DiscountLabel';
import LovedLabel from './lovedLabel/LovedLabel';
import TrustRating from './trustRating/TrustRating';
import parse from 'html-react-parser';
import { Separator } from './separator/separator.styled';
import ProductImage from './productImage/ProductImage';

const MainSimplifiedCardMobile: FC = () => {
	const { postTemplate } = useACF() as { postTemplate?: PostTemplate };
	const main = postTemplate?.review_page_v4_products_section_settings.main_product;

	if (!postTemplate) return null;

	const mainProduct: MainProduct | undefined = postTemplate.review_page_v4_products_section_settings?.main_product;

	const { card_border_color } = mainProduct;

	if (!mainProduct) return null;

	const {
		trust_pilot_rating_image,
		tr_trust_pilot_review_score_label,
		tr_trust_pilot_excellent_label,
		tr_trust_pilot_customer_reviews_label,
		trust_pilot_rating_score,
	} = mainProduct.trustpilot_component;

	const {
		tr_discount_component_discount_text,
		discount_component_discount_label_background,
		discount_component_discount_label_text_color,
	} = mainProduct.discount_component;

	const promotionalCard: PromotionalCard | undefined = postTemplate.review_page_v4_promotional_card_settings;
	if (!promotionalCard) return null;

	const {
		display_promotional_card,
		promotional_card_image,
		tr_promotional_card_heading,
		tr_promotional_card_paragraph,
		promotional_card_cta_link,
	} = promotionalCard;

	const { tr_button_text } = mainProduct.button_component;

	if (!main) return null;

	if (!display_promotional_card) return null;

	return (
		<CardContainer $borderColor={card_border_color}>
			<SimplifiedCardContent>
				<CardContentContainerMobile>
					<ProductImage productImage={promotional_card_image && promotional_card_image} />
					<Separator $height="100%" $spacing="7px" />
					<TrustRating
						reviewLabel={tr_trust_pilot_review_score_label}
						reviewScore={trust_pilot_rating_score}
						reviewEvaluation={tr_trust_pilot_excellent_label}
						reviewCount={tr_trust_pilot_customer_reviews_label}
						reviewImage={trust_pilot_rating_image}
					/>
				</CardContentContainerMobile>
				<CardTextContainer $simplifiedCard={true}>
					<div>
						<SimplifiedCardTitle>{tr_promotional_card_heading}</SimplifiedCardTitle>
					</div>
					<div>
						<SimplifiedCardParagraph>{parse(tr_promotional_card_paragraph)}</SimplifiedCardParagraph>
					</div>
				</CardTextContainer>

				<DiscountLabel
					text={tr_discount_component_discount_text}
					$textColor={discount_component_discount_label_text_color}
					$backgroundColor={discount_component_discount_label_background}
				/>
				<Button href={promotional_card_cta_link?.url} target={promotional_card_cta_link?.target} primary={true}>
					{tr_button_text}
				</Button>
				<LovedLabel />
			</SimplifiedCardContent>
		</CardContainer>
	);
};

export default MainSimplifiedCardMobile;
